<template>
    <div class="modal-mask">
        <div class="jm margem">
            <h2 class="alinha-centro">
                Os seguintes itens estão sem data de fim previsto !
            </h2>
            <div>
                <table class="tabela">
                    <tbody>
                        <tr>
                            <th>Sprint</th>
                            <th>Código</th>
                            <th>Descrição</th>
                            <th>Responsável</th>
                            <th>Início Previsto</th>
                            <th>Fim Previsto</th>
                        </tr>
                        <tr v-for="t in tarefas" :key="t.id">
                            <td>{{ t.sprint.nome }}</td>
                            <td>{{ t.codigo }}</td>
                            <td>
                                <div class="descTarefa">
                                    {{ t.descricao }}
                                </div>
                            </td>
                            <td>{{ t.responsavel }}</td>
                            <td>
                                <input type="date" v-model="t.dtInicio" :min="entregaSelecionada.dtInicio"
                                    :max="t.dtFim || entregaSelecionada.dtFim"
                                    @change="atualizarTarefa(t.id, { dtInicio: t.dtInicio || null })">
                            </td>
                            <td>
                                <input type="date" v-model="t.dtFim" :min="t.dtInicio || entregaSelecionada.dtInicio"
                                    :max="entregaSelecionada.dtFim"
                                    @change="atualizarTarefa(t.id, { dtFim: t.dtFim || null })">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="submit direita">
                <button class="acao-secundaria bg-sucesso"
                    :style="{ 'background-color': itensCorrigidos ? 'var(--cor-sucesso)' : 'var(--cor-erro)' }"
                    @click="fecharModal()">{{ itensCorrigidos ? 'Pronto' : 'Manter assim' }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalTarefasSemData',

    props: {
        propTarefas: {
            default: [],
        },
        propEntregaSelecionada: {
            default: null,
        },
    },

    data() {
        return {
            tarefas: this.propTarefas,
            entregaSelecionada: this.propEntregaSelecionada,
        }
    },

    computed: {
        dataHora() {
            return `${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
        },
        itensCorrigidos() {
            return this.tarefas.filter(t => !t.dtFim).length == 0
        }
    },

    methods: {
        fecharModal() {
            this.$emit('fecharModal')
        },
        atualizarTarefa(id, payload) {
            this.$emit('atualizaTarefa', id, payload)
        }
    },
}
</script>

<style scoped>
.jm {
    max-width: 70vw;
    max-height: 80vh;
    overflow: auto;
}

.descTarefa {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis
}

input[type=date] {
    margin: .2rem 0 !important;
}
</style>